import {
  TRUSTPILOT_FIVE_STAR_COUNT,
  TRUSTPILOT_PROFILE_URL,
} from "@/constants/Trustpilot";

const STAR_PATH =
  "M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z";

/**
 * The hero's Trustpilot badge: how many five-star reviews we have, linking to
 * the profile.
 *
 * It used to show a hard-coded "4.9 Excellent, 932+ reviews" that did not match
 * the real profile. The stars here describe the reviews being counted, not an
 * overall rating. See constants/Trustpilot.ts before changing the wording.
 */
export default function TrustpilotBadge() {
  return (
    <a
      href={TRUSTPILOT_PROFILE_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="group relative inline-block"
      aria-label={`${TRUSTPILOT_FIVE_STAR_COUNT}+ five-star reviews on Trustpilot (opens in a new tab)`}
    >
      {/* Glassmorphic badge container - sleek and minimal */}
      <div className="relative bg-white/90 backdrop-blur-md rounded-lg shadow-[0_4px_24px_rgba(0,0,0,0.12)] border border-white/60 px-5 py-4 transition-all duration-500 group-hover:bg-white/95 group-hover:shadow-[0_8px_32px_rgba(0,0,0,0.16)]">
        <div className="flex items-center justify-center gap-1.5 mb-2.5">
          <svg
            className="w-5 h-5 text-[#00B67A]"
            viewBox="0 0 24 24"
            fill="currentColor"
            aria-hidden="true"
          >
            <path d={STAR_PATH} />
          </svg>
          <span className="text-gray-900 font-bold text-base tracking-tight">
            Trustpilot
          </span>
        </div>

        {/* Trustpilot's own style: white stars on green tiles */}
        <div className="flex items-center justify-center gap-1 mb-2.5" aria-hidden="true">
          {[...Array(5)].map((_, i) => (
            <span
              key={i}
              className="w-5 h-5 rounded-[3px] bg-[#00B67A] flex items-center justify-center"
            >
              <svg
                className="w-3.5 h-3.5 text-white"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d={STAR_PATH} />
              </svg>
            </span>
          ))}
        </div>

        <p className="flex items-center justify-center gap-1 text-sm text-gray-600">
          <span className="font-semibold text-gray-900">
            {TRUSTPILOT_FIVE_STAR_COUNT}+
          </span>
          five-star reviews
          <svg
            className="w-4 h-4 transform group-hover:translate-x-0.5 transition-transform duration-300"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 5l7 7-7 7"
            />
          </svg>
        </p>
      </div>
    </a>
  );
}
